import { useEffect, useRef, useCallback } from 'react'

export const useAttachmentListObserver = (onChange: () => void) => {
  const observerRef = useRef<MutationObserver | null>(null)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const debouncedOnChange = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
    timeoutRef.current = setTimeout(() => {
      onChange()
    }, 100)
  }, [onChange])

  useEffect(() => {
    const attachmentList = document.querySelector('.str-chat__attachment-preview-list')
    if (!attachmentList) {
      const checkInterval = setInterval(() => {
        const list = document.querySelector('.str-chat__attachment-preview-list')
        if (list) {
          clearInterval(checkInterval)
          debouncedOnChange()
        }
      }, 100)
      return () => clearInterval(checkInterval)
    }

    observerRef.current = new MutationObserver(() => {
      debouncedOnChange()
    })

    observerRef.current.observe(attachmentList, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    })

    debouncedOnChange()

    return () => {
      if (observerRef.current) {
        observerRef.current.disconnect()
      }
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [debouncedOnChange])
}

